import StarboxIcon from '../starboxIcon.svg'
import strings from '../strings.js'

export function Root({setLang, lang}) {

return (
    <>
        <div className="topCentreIcon">
            <img
            src={StarboxIcon}
            alt="Starbox"
            />
        </div>
        <div className="tableNoOtherStuff">
        <div className="pleaseEnterTableNo">
        {lang ? strings.cn.loading : strings.en.loading}
        </div>
        <br></br>
        <div className="otherLangTable">
            <div className="otherLangTableNo"
            onClick={(e) => {e.preventDefault(); setLang(false);}}
            style={{ color: lang ? 'black': '#3751fe'}}
            >
                                English
            </div>
            <div className="otherLangTableNo"
            onClick={(e) => {e.preventDefault(); setLang(true);}}
            style={{ color: lang ? '#3751fe' : 'black'}}
            >
                                中文 
            </div>
        </div></div>  
    </>
  )
}
